import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { LondonBetLogoSecondary } from 'src/assets/logos/LondonBetLogoSecondary';
import { LondonBetCompliancePopupLogo } from 'src/assets/logos/LondonBetCompliancePopupLogo';
import { LondonBetBrandIcon } from 'src/assets/brandIcons/LondonBetBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const LondonBetMainLogoWrapper = withConfig(theme => styled('div', { label: 'LondonBetMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const LondonBetMainLogo = styled(LondonBetLogoSecondary, { label: 'LondonBetMainLogo' })`
    width: 148px;
    height: 20px;
    margin: 0 auto;
`;

export const LondonBetBrandIconWrapper = styled(LondonBetBrandIcon, { label: 'LondonBetBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 24px;
    margin: 0 auto;
    width: 24px;
`;

export const CompliancePopupLogo = styled(LondonBetCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
